/**
 * The LpCMSContent component
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Col, Row } from 'reactstrap';

/**
 * Stateless react component to render the LpHeroFullsize component
 * @param {Object} props the props passed to the page.
 */
const LpCMSContent = (props) => {
  const {landingpage} = props;
 
  return (
    <>
     <header className="py-2">
       <Container>
         <Row>
           <Col lg={12}>
             { landingpage.title && <h1 style={{ position: 'relative' }}>{landingpage.title}</h1> }
             { landingpage.subtitle && <h2>{landingpage.subtitle}</h2> }
             { landingpage.intro &&
               <div dangerouslySetInnerHTML={{__html: landingpage.intro}} />
             }
           </Col>
         </Row>
       </Container>
     </header>
      <Container className="my-2">
        { landingpage.content &&
          <div dangerouslySetInnerHTML={{__html: landingpage.content}} />
        }
      </Container>
    </>  
  );
}


/** define proptypes for the form */
LpCMSContent.propTypes = {
  /** the item */
  landingpage: PropTypes.object.isRequired,
};

export default LpCMSContent;
